const {h, render, Component} = require('preact');

class MerchantNameView extends Component {
  constructor(props) {
    super(props);
  }

  getDealMerchantName(currentOrder) {
    if (this.isCurrentOrderMarketRateDeal(currentOrder) || this.isCurrentOrderGetawaysTonightDeal(currentOrder) ||
      (this.isCurrentOrderGetawaysBookingDeal(currentOrder))) {
       let reservationSource = this.getReservationSource(currentOrder)
      return reservationSource.hotelName
    }
    else {
      return currentOrder.merchant.name
    }
  }

  getReservationSource(currentOrder) {
    return currentOrder.reservation || currentOrder.travelBookingInfo.reservation
  }

  isCurrentOrderMarketRateDeal(currentOrder) {
    return this.isCurrentOrderOfDealType(currentOrder, "GETAWAYS_MARKET_RATE")
  }

  isCurrentOrderGetawaysTonightDeal(currentOrder) {
    return this.isCurrentOrderOfDealType(currentOrder, "GETAWAYS_TONIGHT")
  }

  isCurrentOrderGetawaysBookingDeal(currentOrder) {
    return this.isCurrentOrderOfDealType(currentOrder, "GETAWAYS_BOOKING")
  }


  isCurrentOrderOfDealType(currentOrder, deal_type) {
    return currentOrder.DEAL_TYPE == deal_type
  }

  render() {
    return (
        <div className="merchant-info">
        <label> <span className="email-form-merchant-info">{I18n.translate('js.modules.support.merchant')}</span>
          <span className="email-form-merchant-name">{this.getDealMerchantName(this.props.order)}</span>
        </label>
        </div>
    )
  }
}

module.exports = MerchantNameView
